import React, { ComponentPropsWithoutRef } from 'react'

export const BoldIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 9C11.2956 9 12.0587 8.68393 12.6213 8.12132C13.1839 7.55871 13.5 6.79565 13.5 6C13.5 5.20435 13.1839 4.44129 12.6213 3.87868C12.0587 3.31607 11.2956 3 10.5 3H4.5V9"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 15C12.0456 15 12.8087 14.6839 13.3713 14.1213C13.9339 13.5587 14.25 12.7956 14.25 12C14.25 11.2044 13.9339 10.4413 13.3713 9.87868C12.8087 9.31607 12.0456 9 11.25 9H4.5V15H11.25Z"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
